/* tslint:disable */
/* eslint-disable */
/**
 * kiwi-api-dev
 * 走行計画、走行実績、全VEC予実管理, HDmap可視化、POI DB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResultMeta
 */
export interface ResultMeta {
    /**
     * 
     * @type {number}
     * @memberof ResultMeta
     */
    distance: number;
    /**
     * 
     * @type {string}
     * @memberof ResultMeta
     */
    updated_at: string;
    /**
     * 
     * @type {string}
     * @memberof ResultMeta
     */
    result_name: string;
    /**
     * 
     * @type {object}
     * @memberof ResultMeta
     */
    result_id: object;
    /**
     * 
     * @type {string}
     * @memberof ResultMeta
     */
    updated_by: string;
    /**
     * 
     * @type {string}
     * @memberof ResultMeta
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof ResultMeta
     */
    fleet_id: string;
    /**
     * 
     * @type {number}
     * @memberof ResultMeta
     */
    time: number;
    /**
     * 
     * @type {string}
     * @memberof ResultMeta
     */
    created_by: string;
    /**
     * 
     * @type {string}
     * @memberof ResultMeta
     */
    car_id: string;
    /**
     * 
     * @type {string}
     * @memberof ResultMeta
     */
    comment?: string;
}

export function ResultMetaFromJSON(json: any): ResultMeta {
    return ResultMetaFromJSONTyped(json, false);
}

export function ResultMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultMeta {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'distance': json['distance'],
        'updated_at': json['updated_at'],
        'result_name': json['result_name'],
        'result_id': json['result_id'],
        'updated_by': json['updated_by'],
        'created_at': json['created_at'],
        'fleet_id': json['fleet_id'],
        'time': json['time'],
        'created_by': json['created_by'],
        'car_id': json['car_id'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function ResultMetaToJSON(value?: ResultMeta | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'distance': value.distance,
        'updated_at': value.updated_at,
        'result_name': value.result_name,
        'result_id': value.result_id,
        'updated_by': value.updated_by,
        'created_at': value.created_at,
        'fleet_id': value.fleet_id,
        'time': value.time,
        'created_by': value.created_by,
        'car_id': value.car_id,
        'comment': value.comment,
    };
}


